export const actionTypes = {
    VALIDATE_SERIAL_NUMBER: 'powertrainTools/gatewayManagement/VALIDATE_SERIAL_NUMBER',
    VALIDATE_SERIAL_NUMBER_SETTINGS: 'powertrainTools/gatewayManagement/VALIDATE_SERIAL_NUMBER_SETTINGS',
    VALIDATE_SERIAL_NUMBER_CLEAR: 'powertrainTools/gatewayManagement/VALIDATE_SERIAL_NUMBER_CLEAR',
    ASSIGN_SERIAL_NUMBER: 'powertrainTools/gatewayManagement/ASSIGN_SERIAL_NUMBER',
    ASSIGN_SERIAL_NUMBER_SETTINGS: 'powertrainTools/gatewayManagement/ASSIGN_SERIAL_NUMBER_SETTINGS'
};

export const driveTabTitle = {
    singleDrive: 'Single drive',
    cabinetDrive: 'Cabinet drive'
};

export const defaultDriveTab = {
    singleDrive: 'singleDrive',
    cabinetDrive: 'cabinetDrive'
};
